export default function formatMessageContentRichText ({ url }) {
    return {
        url
    }
}
